module.exports = __webpack_public_path__ + "media/images/top/icon/white/ico_headset-42b816f537c5e168907b24dc9770e779.svg";